import React, { useState } from 'react';
import { Swiper } from 'swiper/react';
import SwiperCore from 'swiper';
import { SwiperProps } from './SwiperContainer';

const SwiperPresenter: React.FC<SwiperProps> = (props) => {
  const { PrevBtn, NextBtn, children, ...restProps } = props;
  const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();

  return (
    <Swiper {...restProps} onSwiper={(swiper) => setSwiperInstance(swiper)}>
      {PrevBtn && (
        <div
          onClick={() => {
            swiperInstance?.slidePrev();
          }}
        >
          <PrevBtn />
        </div>
      )}
      {NextBtn && (
        <div
          onClick={() => {
            swiperInstance?.slideNext();
          }}
        >
          <NextBtn />
        </div>
      )}
      {children}
    </Swiper>
  );
};

export default SwiperPresenter;
